import _extends from "@babel/runtime/helpers/extends";
import { TitleDisplay } from './TitleDisplay';
import { Box, Button, Divider } from '@wix/design-system';
import s from './SearchRecommendation.module.scss';
import React from 'react';
import { Label } from './Label';
import { SearchRecommendationListSkeleton } from './SearchRecommendationSkeleton';
import { PricingContent } from '../Pricing/PricingContent';
const SearchRecommendationSharedProps = {
  overflow: 'hidden',
  align: 'space-between',
  verticalAlign: 'middle',
  padding: 'SP4',
  gap: 'SP4',
  borderRadius: '12px'
};
export const SearchRecommendationLayout = {
  SearchRecommendationContainer: _ref => {
    let {
      children,
      ...props
    } = _ref;
    return /*#__PURE__*/React.createElement(Box, _extends({}, SearchRecommendationSharedProps, {
      className: s.searchRecommendationContainer
    }, props), children);
  },
  SearchRecommendationSkeletonContainer: _ref2 => {
    let {
      children,
      ...props
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, _extends({}, SearchRecommendationSharedProps, {
      className: s.searchRecommendationContainer
    }, props), children);
  },
  DomainInfoContainer: _ref3 => {
    let {
      children,
      ...props
    } = _ref3;
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      gap: "SP2",
      margin: "8px 0"
    }, props), children);
  },
  SearchRecommendationListContainer: _ref4 => {
    let {
      children,
      ...props
    } = _ref4;
    return /*#__PURE__*/React.createElement(Box, _extends({
      direction: "vertical",
      display: "flex",
      width: "100%",
      flex: 1
    }, props), children);
  },
  Skeleton: _ref5 => {
    let {
      limit,
      useMobileLayout,
      defaultNonHovered,
      optimized
    } = _ref5;
    return /*#__PURE__*/React.createElement(SearchRecommendationListSkeleton, {
      limit: limit,
      useMobileLayout: useMobileLayout,
      defaultNonHovered: defaultNonHovered,
      optimized: optimized
    });
  },
  GetItButtonContainer: _ref6 => {
    let {
      children
    } = _ref6;
    return /*#__PURE__*/React.createElement(Box, {
      className: s.button
    }, children);
  },
  GetItButton: _ref7 => {
    let {
      children,
      domainName: _domainName,
      ...props
    } = _ref7;
    return /*#__PURE__*/React.createElement(Button, _extends({
      size: "medium",
      skin: "dark"
    }, props), children);
  },
  Label: _ref8 => {
    let {
      ...props
    } = _ref8;
    return /*#__PURE__*/React.createElement(Label, props);
  },
  LabelContainer: _ref9 => {
    let {
      children,
      premium,
      visible
    } = _ref9;
    return visible || premium ? /*#__PURE__*/React.createElement(Box, {
      gap: "6px",
      verticalAlign: "middle",
      flexWrap: "wrap"
    }, children) : null;
  },
  PricingWrapper: _ref10 => {
    let {
      children,
      ...props
    } = _ref10;
    return /*#__PURE__*/React.createElement(Box, props, children);
  },
  PricingContent,
  TitleDisplay: _ref11 => {
    let {
      children,
      ...props
    } = _ref11;
    return /*#__PURE__*/React.createElement(TitleDisplay, props, children);
  },
  ActionsContainer: _ref12 => {
    let {
      children,
      ...props
    } = _ref12;
    return /*#__PURE__*/React.createElement(Box, _extends({
      gap: "16px",
      verticalAlign: "middle",
      align: "space-between",
      marginLeft: "auto"
    }, props), children);
  },
  /**
   * Mobile-only: lays out the pricing and action buttons under the domain
   * title. Default renders pricing on its own row, then the action row
   * (AI Insights ↔ Get It if AI Insights is present, otherwise Get It alone
   * right-aligned). Override at the call site to change the layout, e.g.
   * to render pricing inline with Get It on a single row.
   */
  MobileActions: _ref13 => {
    let {
      pricing,
      getItButton,
      aiInsightsButton,
      inline
    } = _ref13;
    return inline ? /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      align: "space-between",
      verticalAlign: "middle",
      width: "100%",
      gap: "SP4",
      flexWrap: "wrap"
    }, pricing, /*#__PURE__*/React.createElement(Box, {
      flexShrink: 0,
      marginLeft: "auto"
    }, getItButton)) : /*#__PURE__*/React.createElement(React.Fragment, null, pricing, /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      align: aiInsightsButton ? 'space-between' : 'right',
      verticalAlign: "middle",
      width: "100%"
    }, aiInsightsButton, getItButton));
  },
  Divider: _ref14 => {
    let {
      className,
      dataHook
    } = _ref14;
    return /*#__PURE__*/React.createElement(Divider, {
      className: className,
      dataHook: dataHook
    });
  },
  HoverBox: _ref15 => {
    let {
      children,
      ...props
    } = _ref15;
    return /*#__PURE__*/React.createElement(Box, props, children);
  },
  InlineExtras: _props => null,
  DomainNote: _props => null,
  Footer: _props => null
};
//# sourceMappingURL=SearchRecommendation.layout.js.map